import { create } from "zustand"
import { User } from "@/types/user"
import { AuthService } from "@/services/auth.service"

interface AuthState {
  user: User | null
  loading: boolean
  login: (credentials: { email: string; password: string }) => Promise<void>
  loginWithMagicLink: (email: string) => Promise<void>
  register: (data: { name: string; email: string; password: string }) => Promise<void>
  resetPassword: (email: string) => Promise<void>
  changePassword: (newPassword: string) => Promise<void>
  logout: () => Promise<void>
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,

  login: async ({ email, password }) => {
    set({ loading: true })
    try {
      const { user } = await AuthService.login(email, password)
      set({ user })
    } finally {
      set({ loading: false })
    }
  },

  loginWithMagicLink: async (email) => {
    set({ loading: true })
    try {
      await AuthService.loginWithMagicLink(email)
    } finally {
      set({ loading: false })
    }
  },

  register: async ({ name, email, password }) => {
    set({ loading: true })
    try {
      const { user } = await AuthService.register({ name, email, password })
      set({ user })
    } finally {
      set({ loading: false })
    }
  },

  resetPassword: async (email) => {
    await AuthService.resetPassword(email)
  },

  changePassword: async (newPassword) => {
    await AuthService.changePassword(newPassword)
  },

  logout: async () => {
    set({ loading: true })
    try {
      await AuthService.logout()
      set({ user: null })
    } finally {
      set({ loading: false })
    }
  },

  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading })
})) 